import { AsanaIcon } from "#components/ui/AsanaIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const asanaManifest: IntegrationManifest = {
    key: "asana",
    displayName: "Asana",
    nameKey: "channels.asana",
    descriptionKey: "asanaDescription",
    trayDescriptionKey: "composerTrayDescriptions.asana",
    cardDescriptionKey: "connectIntegration.descriptions.asana",
    connectedContentKeys: ["asanaTasks"],
    brandColor: "#F06A6A",
    iconUrl: IconAssets.Asana,
    iconUrlAlt: IconAssets.AsanaAlt,
    glyph: AsanaIcon,
    channelType: "UserAsanaMcp",
    // Remote-MCP citations resolve via customProperties.integrationKey, not a DataSource.
    dataSources: []
};
